import React from 'react';
import { getTextColor } from './Bookconfig';

// Simple pill-style book picker.
// onChange is called with the book's id directly.
function Bookselector({ books, bookId, onChange }) {
  return (
    <div
      className="book-picker"
      role="radiogroup"
      aria-label="Choose your book"
    >
      {books.map((book) => {
        const isActive = book.id === bookId;

        return (
          <button
            key={book.id}
            type="button"
            role="radio"
            aria-checked={isActive}
            className={`book-pill ${isActive ? 'active' : ''} ${
              book.isBundle ? 'bundle-pill' : ''
            }`}
            style={{
              '--pill-color': book.isBundle ? '#9a9f7a' : book.color,
              '--pill-text': book.isBundle
                ? '#3f4630'
                : getTextColor(book.color),
            }}
            onClick={() => onChange(book.id)}
          >
            <span className="book-pill-title">
              {book.isBundle
                ? 'Both books'
                : book.title}
            </span>

            {book.isBundle && (
              <span className="book-pill-badge">Save 15%</span>
            )}
          </button>
        );
      })}
    </div>
  );
}

export default Bookselector;